import { State as TestState } from "@client/reducers/test-reducer";
import { Selector } from "@ngrx/store";
export const getIsActive: Selector<TestState, boolean> = (state: TestState) => state.isActive;
export const getActivePage: Selector<TestState, string> = (state: TestState) => state.activePage;
